import { useEffect, useState } from 'react'
import { getRegion } from './checkout.js'

let regionRequest

export default function useMacPrice() {
  const [country, setCountry] = useState(null)

  useEffect(() => {
    let active = true
    regionRequest ??= getRegion()
    regionRequest.then(region => {
      if (active) setCountry(region.country)
    })
    return () => { active = false }
  }, [])

  // Show both prices if geolocation is unavailable. Polar resolves the final
  // currency on its hosted checkout using the buyer's location.
  if (!country) return '₱199 in PH / $4.99 USD elsewhere'
  return country === 'PH' ? '₱199' : '$4.99 USD'
}
